"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgElphaLogoSvg = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 85, height: 80, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M44.666 0C27.895 0 13.533 10.283 7.551 24.864h4.476a6.32 6.32 0 0 1 2.208.398c9.83-1.502 18.403.988 25.552 8.07 1.969 1.953 3.889 3.995 6.08 5.668a13.38 13.38 0 0 0 5.112 2.402c2.99.648 5.202-1.204 5.63-4.23.348-2.445-.17-4.782-1.7-6.636-1.78-2.158-3.841-4.114-5.933-5.978-.82-.734-.975-1.16-.4-2.057 1.03-1.616 1.892-3.339 2.944-4.94.241-.367 1.09-.718 1.453-.571C63.18 21.154 70.34 30.41 70.098 41.324c-.18 8.042-4.598 14.503-11.336 16.52-4.663 1.395-9.302.825-13.887-.485-1.163-.334-2.292-.783-3.729-1.28 1.472 2.962 2.927 5.678 3.067 9.091a16.915 16.915 0 0 0-6.161-1.91 13.67 13.67 0 0 0-2.846-.114c-.437.027-.87.1-1.291.218-5.081.788-9.65 3.988-13.125 8.774a39.956 39.956 0 0 0 23.875 7.868c22.14 0 40.086-17.91 40.086-40C84.751 17.913 66.806 0 44.666 0ZM5.4 48.08c0 .023 0 .046.013.07l.01-.066-.023-.003Z", fill: "#5029EF" }), (0, jsx_runtime_1.jsx)("path", { d: "M28.34 42.456a3.349 3.349 0 0 0 3.353-3.346c0-1.847-1.5-3.344-3.352-3.344a3.349 3.349 0 0 0-3.353 3.345c0 1.847 1.501 3.345 3.353 3.345Z", fill: "#5029EF" }), (0, jsx_runtime_1.jsx)("path", { d: "M29.015 36.457h-1.347c-.554 0-1.003.448-1.003 1v7.096c0 .553.45 1 1.003 1h1.347c.554 0 1.002-.447 1.002-1v-7.095c0-.553-.448-1-1.002-1ZM6.27 48.14a6.277 6.277 0 0 1-4.433-1.832A6.25 6.25 0 0 1 0 41.884v2.14c0 3.456 2.596 6.257 5.796 6.257h8.588a2.597 2.597 0 0 0 2.554-2.14H6.27Z", fill: "#5029EF" })] }))); };
exports.default = SvgElphaLogoSvg;
